var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-tutorial"},[_c('v-icon',{staticStyle:{"font-size":"1em"}},[_vm._v("help")]),_vm._v(" "),_c('a',{on:{"click":_vm.toggleTutorial}},[(_vm.disabled)?[_vm._v("Show tutorials")]:[_vm._v("Hide Tutorials")]],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02000866","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/TutorialToggle.vue
// module id = QRA+
// module chunks = 1